import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { sync } from "vuex-router-sync";
import store from "./store";
import vbclass from "vue-body-class";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { configure } from "vee-validate";

import "./assets/less/app.less";
import router from "./router";
import i18n from "./i18n";

Vue.use(VueAxios, axios);
Vue.use(vbclass, router);
Vue.config.productionTip = false;

// Setup form validation
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
extend("required", required);
extend("email", email);

configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid"
  }
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
  beforeCreate() {
    this.$store.commit("initialiseStore");
  }
}).$mount("#app");

// Initialize vuex-router-sync
sync(store, router);
